import { ReportConfig } from "../definitions";

const executiveSummary: ReportConfig = {
  id: "executive-summary",
  name: "Executive Summary YTD",
  print: { linearize: false, bodyClass: "single-page-print" },
  options: [
    { name: "startDate", label: "Start Date", dataType: "date", defaultValue: "$YEAR-01-01" },
    { name: "endDate", label: "End Date", dataType: "date", defaultValue: "$YEAR-$MONTH-$DAY" },
    {
      name: "branch",
      label: "Branch",
      dataType: "multi-select-dynamic",
      config: { showSelectAll: true },
      defaultValueOther: [1],
      // defaultValueOther: [1, 2, 3, 4, 105, 107, 108, 109],
      optionsDataSource: {
        sql: `
        SELECT ID, Type
        FROM [dbo].[BranchType]
        WHERE (IsDeleted IS NULL OR IsDeleted = 0) AND ID IN (1, 2, 3, 4, 105, 107, 108, 109, 110, 100) `,
        returnType: "options",
      },
    },
  ],
  layout: [
    {
      items: [
        {
          id: "quarterly-production",
          title: "",
          // title: "Quarterly Production",
          widgetType: "table",
          headerColumns: [
            { name: "", type: "string", align: "center", colSpan: 1 },
            { name: "Q1", type: "string", align: "center", colSpan: 2 },
            { name: "Q2", type: "string", align: "center", colSpan: 2 },
            { name: "Q3", type: "string", align: "center", colSpan: 2 },
            { name: "Q4", type: "string", align: "center", colSpan: 2 },
          ],
          columns: [
            { name: "", type: "string" },
            { name: " Policies", type: "number", align: "right" },
            { name: " Premium", type: "currency", align: "right" },
            { name: " Policies", type: "number", align: "right" },
            { name: " Premium", type: "currency", align: "right" },
            { name: " Policies", type: "number", align: "right" },
            { name: " Premium", type: "currency", align: "right" },
            { name: " Policies", type: "number", align: "right" },
            { name: " Premium", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
-- declare @startDate date;
-- declare @endDate date;
--  set @startDate = '2024-01-01';
-- set @endDate = '2024-12-31';

IF @branch IS NULL OR @branch = ''
BEGIN
  PRINT 'You must select a branch'
  RETURN
END
ELSE
BEGIN

-- Create a table variable to hold the branch IDs
DECLARE @branchTable TABLE (BranchID INT);
INSERT INTO @branchTable (BranchID)
SELECT TRY_CAST(value AS INT)
FROM STRING_SPLIT(@branch, ',')
WHERE TRY_CAST(value AS INT) IS NOT NULL;

WITH YTDApplications AS (
  SELECT
    DATEPART(Q, a.EntryDate) as 'Q',
      COUNT(*) AS ApplicationsWritten,
      SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumWritten
    FROM [awu].[Application] [a]
      LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
      LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    WHERE a.BranchTypeID in (SELECT * FROM @branchTable)
      AND (@_branch = 0 OR a.BranchTypeID = @_branch)
      AND [a].[EntryDate] BETWEEN @startDate AND @endDate
      AND st.[ScenarioTypeCode] = 'F'
    GROUP BY DATEPART(Q, a.EntryDate)
),
YTDPaidApplications AS (
  SELECT
    DATEPART(Q, a.PaidOrClosedDate) as 'Q',
    COUNT(*) AS ApplicationsPaid,
    SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumPaid
  FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
  WHERE a.BranchTypeID in (SELECT * FROM @branchTable)
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
    AND [a].[PaidOrClosedDate] BETWEEN @startDate AND @endDate
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
  GROUP BY DATEPART(Q, a.PaidOrClosedDate)
)

SELECT
    'DI Written' as 'Type',
    ISNULL(SUM(CASE WHEN ytd.Q = 1 THEN [ytd].[ApplicationsWritten] END), 0) as 'Q1 Policies',
    ISNULL(SUM(CASE WHEN ytd.Q = 1 THEN [ytd].[TotalPremiumWritten] END), 0) as 'Q1 Premium',
    ISNULL(SUM(CASE WHEN ytd.Q = 2 THEN [ytd].[ApplicationsWritten] END), 0) as 'Q2 Policies',
    ISNULL(SUM(CASE WHEN ytd.Q = 2 THEN [ytd].[TotalPremiumWritten] END), 0) as 'Q2 Premium',
    ISNULL(SUM(CASE WHEN ytd.Q = 3 THEN [ytd].[ApplicationsWritten] END), 0) as 'Q3 Policies',
    ISNULL(SUM(CASE WHEN ytd.Q = 3 THEN [ytd].[TotalPremiumWritten] END), 0) as 'Q3 Premium',
    ISNULL(SUM(CASE WHEN ytd.Q = 4 THEN [ytd].[ApplicationsWritten] END), 0) as 'Q4 Policies',
    ISNULL(SUM(CASE WHEN ytd.Q = 4 THEN [ytd].[TotalPremiumWritten] END), 0) as 'Q4 Premium'
FROM YTDApplications [ytd]
UNION
SELECT
    'DI Paid' as 'Type',
    ISNULL(SUM(CASE WHEN ytdp.Q = 1 THEN [ytdp].[ApplicationsPaid] END), 0) as 'Q1 Policies',
    ISNULL(SUM(CASE WHEN ytdp.Q = 1 THEN [ytdp].[TotalPremiumPaid] END), 0) as 'Q1 Premium',
    ISNULL(SUM(CASE WHEN ytdp.Q = 2 THEN [ytdp].[ApplicationsPaid] END), 0) as 'Q2 Policies',
    ISNULL(SUM(CASE WHEN ytdp.Q = 2 THEN [ytdp].[TotalPremiumPaid] END), 0) as 'Q2 Premium',
    ISNULL(SUM(CASE WHEN ytdp.Q = 3 THEN [ytdp].[ApplicationsPaid] END), 0) as 'Q3 Policies',
    ISNULL(SUM(CASE WHEN ytdp.Q = 3 THEN [ytdp].[TotalPremiumPaid] END), 0) as 'Q3 Premium',
    ISNULL(SUM(CASE WHEN ytdp.Q = 4 THEN [ytdp].[ApplicationsPaid] END), 0) as 'Q4 Policies',
    ISNULL(SUM(CASE WHEN ytdp.Q = 4 THEN [ytdp].[TotalPremiumPaid] END), 0) as 'Q4 Premium'
FROM YTDPaidApplications [ytdp]

END
            `,
            returnType: "table",
          },
        },
      ],
    },
    {
      items: [
        {
          id: "written",
          title: "DI Written",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string", align: "left" },
            { name: "Policies", type: "number", align: "right", summary: "sum" },
            { name: "AYTD", type: "currency", align: "right", summary: "sum" },
            { name: "Average", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
    IF @branch IS NULL OR @branch = ''
    BEGIN
      PRINT 'You must select a branch'
      RETURN
    END
    ELSE
    BEGIN

    declare @projectionMultiplier float = 365.0 / datepart(dayofyear, getdate());

    -- Create a table variable to hold the branch IDs
    DECLARE @branchTable TABLE (BranchID INT);
    INSERT INTO @branchTable (BranchID)
    SELECT TRY_CAST(value AS INT)
    FROM STRING_SPLIT(@branch, ',')
    WHERE TRY_CAST(value AS INT) IS NOT NULL;

    WITH YTDApplications AS (
      SELECT
          [a].[CarrierID],
          COUNT(DISTINCT a.id) AS ApplicationsWritten,
          SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumWritten
        FROM [awu].[Application] [a]
          INNER JOIN [awu].[Plan] pl ON a.[PlanID] = pl.ID AND pl.PlanTypeID NOT IN (315, 316, 1996, 44485, 45469, 47853, 49269)
          LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
          LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
        WHERE a.BranchTypeID IN (SELECT * FROM @branchTable)
          AND (@_branch = 0 OR a.BranchTypeID = @_branch)
          AND [a].[EntryDate] BETWEEN @startDate and @endDate
          AND st.[ScenarioTypeCode] = 'F'
        GROUP BY [a].[CarrierID]
    )

    SELECT
        [ct].[Type] AS CarrierName,
        ISNULL([ytd].[ApplicationsWritten], 0) AS ApplicationsWrittenYTD,
        ISNULL([ytd].[TotalPremiumWritten], 0) AS TotalPremiumWrittenYTD,
        CASE
            WHEN ISNULL([ytd].[ApplicationsWritten], 0) = 0 THEN NULL
            ELSE ISNULL([ytd].[TotalPremiumWritten], 0) / ISNULL([ytd].[ApplicationsWritten], 0)
          END AS AverageWritten,
        0 as [Section]
    FROM [dbo].[CarrierType] [ct]
      LEFT JOIN YTDApplications [ytd] ON [ct].[ID] = [ytd].[CarrierID]
    WHERE ([ct].[IsDeleted] = 0 OR [ct].[IsDeleted] IS NULL)
        AND ([ytd].[CarrierID] IS NOT NULL OR [ytd].[CarrierID] IS NOT NULL)
        AND [ct].[IsDeleted] = 0

    UNION

    SELECT 'Total' AS CarrierName,
        SUM(ISNULL([ytd].[ApplicationsWritten], 0)) AS ApplicationsWrittenYTD,
        SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) AS TotalPremiumWrittenYTD,
        CASE
        WHEN SUM(ISNULL([ytd].[ApplicationsWritten], 0)) = 0 THEN NULL
        ELSE SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) / SUM(ISNULL([ytd].[ApplicationsWritten], 0))
        END AS AverageWritten,
        1 as [Section]
    FROM [dbo].[CarrierType] [ct]
      LEFT JOIN YTDApplications [ytd] ON [ct].[ID] = [ytd].[CarrierID]
    WHERE ([ct].[IsDeleted] = 0 OR [ct].[IsDeleted] IS NULL)
        AND ([ytd].[CarrierID] IS NOT NULL OR [ytd].[CarrierID] IS NOT NULL)
        AND [ct].[IsDeleted] = 0

    UNION

    SELECT 'Projection' AS CarrierName,
        FLOOR(SUM(ISNULL([ytd].[ApplicationsWritten], 0)) * @projectionMultiplier) AS ApplicationsWrittenYTD,
        SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) * @projectionMultiplier AS TotalPremiumWrittenYTD,
        CASE
        WHEN SUM(ISNULL([ytd].[ApplicationsWritten], 0)) = 0 THEN NULL
        ELSE SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) / SUM(ISNULL([ytd].[ApplicationsWritten], 0)) * @projectionMultiplier
        END AS AverageWritten,
        2 as [Section]
    FROM [dbo].[CarrierType] [ct]
      LEFT JOIN YTDApplications [ytd] ON [ct].[ID] = [ytd].[CarrierID]
    WHERE ([ct].[IsDeleted] = 0 OR [ct].[IsDeleted] IS NULL)
        AND ([ytd].[CarrierID] IS NOT NULL OR [ytd].[CarrierID] IS NOT NULL)
        AND [ct].[IsDeleted] = 0

    ORDER BY Section, [TotalPremiumWrittenYTD] DESC
    END
    `,
            returnType: "table",
          },
          options: { summaryInData: true, summaryRows: 2 },
        },
        {
          id: "paid",
          title: "DI Paid",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string", align: "left" },
            { name: "Policies", type: "number", align: "right", summary: "sum" },
            { name: "AYTD", type: "currency", align: "right", summary: "sum" },
            { name: "Average", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
    IF @branch IS NULL OR @branch = ''
    BEGIN
      PRINT 'You must select a branch'
      RETURN
    END
    ELSE
    BEGIN

    declare @projectionMultiplier float = 365.0 / datepart(dayofyear, getdate());

    -- Create a table variable to hold the branch IDs
    DECLARE @branchTable TABLE (BranchID INT);
    INSERT INTO @branchTable (BranchID)
    SELECT TRY_CAST(value AS INT)
    FROM STRING_SPLIT(@branch, ',')
    WHERE TRY_CAST(value AS INT) IS NOT NULL;

    WITH YTDApplications AS (
      SELECT
          [a].[CarrierID],
          COUNT(*) AS ApplicationsWritten,
          ISNULL(SUM([ap].[AnnualizedPremium]), 0) AS TotalPremiumWritten
        FROM [awu].[Application] [a]
          INNER JOIN [awu].[Plan] pl ON a.[PlanID] = pl.ID AND pl.PlanTypeID NOT IN (315, 316, 1996, 44485, 45469, 47853, 49269)
          LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
          LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
        WHERE a.BranchTypeID in (SELECT * FROM @branchTable)
          AND (@_branch = 0 OR a.BranchTypeID = @_branch)
          AND [a].[EntryDate] BETWEEN @startDate and @endDate
          AND st.[ScenarioTypeCode] = 'F'
        GROUP BY [a].[CarrierID]
    ),
    YTDPaidApplications AS (
      SELECT
        [a].[CarrierID],
        COUNT(*) AS ApplicationsPaid,
        SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumPaid
      FROM [awu].[Application] [a]
        LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
        LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
        --LEFT JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
      WHERE a.BranchTypeID in (SELECT * FROM @branchTable)
        AND (@_branch = 0 OR a.BranchTypeID = @_branch)
        AND [a].[PaidOrClosedDate] BETWEEN @startDate and @endDate
        AND st.[ApplicationStatusCode] in ('2', '3', 'P')
        AND st.[ScenarioTypeCode] = 'F'
        --AND aa.CommissionLevel = 1
      GROUP BY [a].[CarrierID]
    )

    SELECT
        [ct].[Type] AS CarrierName,
        ISNULL([ytdp].[ApplicationsPaid], 0) AS ApplicationsPaidYTD,
        ISNULL([ytdp].[TotalPremiumPaid], 0) AS TotalPremiumPaidYTD,
        CASE
            WHEN ISNULL([ytdp].[ApplicationsPaid], 0) = 0 THEN NULL
            ELSE ISNULL([ytdp].[TotalPremiumPaid], 0) / ISNULL([ytdp].[ApplicationsPaid], 0)
        END AS AveragePaid,
        0 as [Section]
    FROM [dbo].[CarrierType] [ct]
      LEFT JOIN YTDPaidApplications [ytdp] ON [ct].[ID] = [ytdp].[CarrierID]
    WHERE [ct].[IsDeleted] = 0
        AND [ytdp].[CarrierID] IS NOT NULL
        AND [ct].[IsDeleted] = 0

    UNION

    SELECT
        'Total' AS CarrierName,
        SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) AS ApplicationsPaidYTD,
        SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) AS TotalPremiumPaidYTD,
        CASE
            WHEN SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) = 0 THEN NULL
            ELSE SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) / SUM(ISNULL([ytdp].[ApplicationsPaid], 0))
        END AS AveragePaid,
        1 as [Section]
    FROM [dbo].[CarrierType] [ct]
      LEFT JOIN YTDPaidApplications [ytdp] ON [ct].[ID] = [ytdp].[CarrierID]
    WHERE [ct].[IsDeleted] = 0
        AND [ytdp].[CarrierID] IS NOT NULL
        AND [ct].[IsDeleted] = 0

    UNION

    SELECT
        'Projection' AS CarrierName,
        FLOOR(SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) * @projectionMultiplier) AS ApplicationsPaidYTD,
        SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) * @projectionMultiplier AS TotalPremiumPaidYTD,
        CASE
            WHEN SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) = 0 THEN NULL
            ELSE SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) / SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) * @projectionMultiplier
        END AS AveragePaid,
        2 as [Section]
    FROM [dbo].[CarrierType] [ct]
      LEFT JOIN YTDPaidApplications [ytdp] ON [ct].[ID] = [ytdp].[CarrierID]
    WHERE [ct].[IsDeleted] = 0
        AND [ytdp].[CarrierID] IS NOT NULL
        AND [ct].[IsDeleted] = 0


    ORDER BY Section, [TotalPremiumPaidYTD] DESC
    END
    `,
            returnType: "table",
          },
          options: { summaryInData: true, summaryRows: 2 },
        },
      ],
    },
    {
      items: [
        {
          id: "ltc-written",
          title: "LTC Written",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string", align: "left" },
            { name: "Policies", type: "number", align: "right" },
            { name: "AYTD", type: "currency", align: "right" },
            { name: "Average", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
    IF @branch IS NULL OR @branch = ''
    BEGIN
      PRINT 'You must select a branch'
      RETURN
    END
    ELSE
    BEGIN

    declare @projectionMultiplier float = 365.0 / datepart(dayofyear, getdate());

    -- Create a table variable to hold the branch IDs
    DECLARE @branchTable TABLE (BranchID INT);
    INSERT INTO @branchTable (BranchID)
    SELECT TRY_CAST(value AS INT)
    FROM STRING_SPLIT(@branch, ',')
    WHERE TRY_CAST(value AS INT) IS NOT NULL;

    WITH YTDApplications AS (
      SELECT
          [a].[CarrierID],
          COUNT(*) AS ApplicationsWritten,
          SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumWritten
        FROM [awu].[Application] [a]
          LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
          LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
          LEFT JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
        WHERE a.BranchTypeID in (SELECT * FROM @branchTable)
          AND (@_branch = 0 OR a.BranchTypeID = @_branch)
          AND [a].[EntryDate] BETWEEN @startDate and @endDate
          AND st.[ScenarioTypeCode] = 'F'
          AND aa.CommissionLevel = 1
          AND a.PlanID IN (315,316,1996,44485,45469,47853,49269)
          AND a.isDeleted = 0
        GROUP BY [a].[CarrierID]
    )

    SELECT
        [ct].[Type] AS CarrierName,
        ISNULL([ytd].[ApplicationsWritten], 0) AS ApplicationsWrittenYTD,
        ISNULL([ytd].[TotalPremiumWritten], 0) AS TotalPremiumWrittenYTD,
        CASE
            WHEN ISNULL([ytd].[ApplicationsWritten], 0) = 0 THEN NULL
            ELSE ISNULL([ytd].[TotalPremiumWritten], 0) / ISNULL([ytd].[ApplicationsWritten], 0)
          END AS AverageWritten,
        0 as [Section]
    FROM [dbo].[CarrierType] [ct]
      LEFT JOIN YTDApplications [ytd] ON [ct].[ID] = [ytd].[CarrierID]
    WHERE ([ct].[IsDeleted] = 0 OR [ct].[IsDeleted] IS NULL)
        AND ([ytd].[CarrierID] IS NOT NULL OR [ytd].[CarrierID] IS NOT NULL)
        AND [ct].[IsDeleted] = 0

    UNION

    SELECT
        'Total' AS CarrierName,
        SUM(ISNULL([ytd].[ApplicationsWritten], 0)) AS ApplicationsWrittenYTD,
        SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) AS TotalPremiumWrittenYTD,
        CASE
            WHEN SUM(ISNULL([ytd].[ApplicationsWritten], 0)) = 0 THEN NULL
            ELSE SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) / SUM(ISNULL([ytd].[ApplicationsWritten], 0))
          END AS AverageWritten,
        1 as [Section]
    FROM YTDApplications [ytd]

    UNION

    SELECT
        'Projection' AS CarrierName,
        ROUND(@projectionMultiplier * SUM(ISNULL([ytd].[ApplicationsWritten], 0)),1) AS ApplicationsWrittenYTD,
        @projectionMultiplier * SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) AS TotalPremiumWrittenYTD,
        CASE
            WHEN SUM(ISNULL([ytd].[ApplicationsWritten], 0)) = 0 THEN NULL
            ELSE @projectionMultiplier * SUM(ISNULL([ytd].[TotalPremiumWritten], 0)) / (@projectionMultiplier * SUM(ISNULL([ytd].[ApplicationsWritten], 0)))
          END AS AverageWritten,
        2 as [Section]
    FROM YTDApplications [ytd]



    ORDER BY Section, TotalPremiumWrittenYTD DESC
    END
    `,
            returnType: "table",
          },
          options: { summaryInData: true, summaryRows: 2 },
        },
        {
          id: "ltc-paid",
          title: "LTC Paid",
          widgetType: "table",
          columns: [
            { name: "Carrier", type: "string", align: "left" },
            { name: "Policies", type: "number", align: "right", summary: "sum" },
            { name: "AYTD", type: "currency", align: "right", summary: "sum" },
            { name: "Average", type: "currency", align: "right" },
          ],
          dataSource: {
            sql: `
    IF @branch IS NULL OR @branch = ''
    BEGIN
      PRINT 'You must select a branch'
      RETURN
    END
    ELSE
    BEGIN

    declare @projectionMultiplier float = 365.0 / datepart(dayofyear, getdate());


    -- Create a table variable to hold the branch IDs
    DECLARE @branchTable TABLE (BranchID INT);
    INSERT INTO @branchTable (BranchID)
    SELECT TRY_CAST(value AS INT)
    FROM STRING_SPLIT(@branch, ',')
    WHERE TRY_CAST(value AS INT) IS NOT NULL;

    WITH YTDPaidApplications AS (
      SELECT
        [a].[CarrierID],
        COUNT(*) AS ApplicationsPaid,
        SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumPaid
      FROM [awu].[Application] [a]
        LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
        LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
        LEFT JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
      WHERE a.BranchTypeID in (SELECT * FROM @branchTable)
        AND (@_branch = 0 OR a.BranchTypeID = @_branch)
        AND [a].[PaidOrClosedDate] BETWEEN @startDate and @endDate
        AND st.[ApplicationStatusCode] in ('2', '3', 'P')
        AND st.[ScenarioTypeCode] = 'F'
        AND aa.CommissionLevel = 1
        AND a.PlanID IN (315,316,1996,44485,45469,47853,49269)
        AND a.isDeleted = 0
      GROUP BY [a].[CarrierID]
    )

    SELECT
        [ct].[Type] AS CarrierName,
        ISNULL([ytdp].[ApplicationsPaid], 0) AS ApplicationsPaidYTD,
        ISNULL([ytdp].[TotalPremiumPaid], 0) AS TotalPremiumPaidYTD,
        CASE
            WHEN ISNULL([ytdp].[ApplicationsPaid], 0) = 0 THEN NULL
            ELSE ISNULL([ytdp].[TotalPremiumPaid], 0) / ISNULL([ytdp].[ApplicationsPaid], 0)
        END AS AveragePaid,
        0 as [Section]
    FROM [dbo].[CarrierType] [ct]
      LEFT JOIN YTDPaidApplications [ytdp] ON [ct].[ID] = [ytdp].[CarrierID]
    WHERE [ct].[IsDeleted] = 0
        AND [ytdp].[CarrierID] IS NOT NULL
        AND [ct].[IsDeleted] = 0

    UNION

    SELECT
        'Total' AS CarrierName,
        SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) AS ApplicationsPaidYTD,
        SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) AS TotalPremiumPaidYTD,
        CASE
            WHEN SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) = 0 THEN NULL
            ELSE SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) / SUM(ISNULL([ytdp].[ApplicationsPaid], 0))
        END AS AveragePaid,
        1 as [Section]
    FROM YTDPaidApplications [ytdp]

    UNION

    SELECT
        'Projection' AS CarrierName,
        ROUND(@projectionMultiplier * SUM(ISNULL([ytdp].[ApplicationsPaid], 0)),1) AS ApplicationsPaidYTD,
        @projectionMultiplier * SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) AS TotalPremiumPaidYTD,
        CASE
            WHEN SUM(ISNULL([ytdp].[ApplicationsPaid], 0)) = 0 THEN NULL
            ELSE @projectionMultiplier * SUM(ISNULL([ytdp].[TotalPremiumPaid], 0)) / SUM(ISNULL([ytdp].[ApplicationsPaid], 0))
        END AS AveragePaid,
        2 as [Section]
    FROM YTDPaidApplications [ytdp]

    ORDER BY Section, TotalPremiumPaidYTD DESC
    END
    `,
            returnType: "table",
          },
          options: { summaryInData: true, summaryRows: 2 },
        },
      ],
    },
    {
      items: [
        {
          id: "written-history",
          title: "Written History",
          widgetType: "table",
          options: { summary: true, singleCol: true },
          columns: [
            { name: "Year", type: "string", align: "left", style: { width: "50px" } },
            { name: "Policies", type: "number", align: "right", summary: "sum", style: { width: "50px" } },
            { name: "Premium", type: "currency", align: "right", summary: "sum" },
          ],
          dataSource: {
            sql: `
    IF @branch IS NULL OR @branch = ''
    BEGIN
      PRINT 'You must select a branch'
      RETURN
    END
    ELSE
    BEGIN

    -- Create a table variable to hold the branch IDs
    DECLARE @branchTable TABLE (BranchID INT);
    INSERT INTO @branchTable (BranchID)
    SELECT TRY_CAST(value AS INT)
    FROM STRING_SPLIT(@branch, ',')
    WHERE TRY_CAST(value AS INT) IS NOT NULL;

    SELECT
          YEAR([a].[EntryDate]) as 'Year',
          COUNT(*) AS ApplicationsWritten,
          SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumWritten
    FROM [awu].[Application] [a]
          LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
          LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    WHERE a.BranchTypeID in (SELECT * FROM @branchTable)
          AND st.[ScenarioTypeCode] = 'F'
          AND YEAR([a].[EntryDate]) > YEAR(GETDATE()) - 10
          AND (a.[IsDeleted] = 0 OR a.[IsDeleted] IS NULL)
          AND (@_branch = 0 OR a.BranchTypeID = @_branch)
    GROUP BY YEAR([a].[EntryDate])
    ORDER BY YEAR([a].[EntryDate])

    END
    `,
            returnType: "table",
          },
        },
        {
          id: "paid-history",
          title: "Paid History",
          widgetType: "table",
          options: { summary: true, singleCol: true },
          columns: [
            { name: "Year", type: "string", align: "left", style: { width: "50px" } },
            { name: "Policies", type: "number", align: "right", summary: "sum", style: { width: "50px" } },
            { name: "Premium", type: "currency", align: "right", summary: "sum" },
          ],
          dataSource: {
            sql: `
    IF @branch IS NULL OR @branch = ''
    BEGIN
      PRINT 'You must select a branch'
      RETURN
    END
    ELSE
    BEGIN

    -- Create a table variable to hold the branch IDs
    DECLARE @branchTable TABLE (BranchID INT);
    INSERT INTO @branchTable (BranchID)
    SELECT TRY_CAST(value AS INT)
    FROM STRING_SPLIT(@branch, ',')
    WHERE TRY_CAST(value AS INT) IS NOT NULL;

    SELECT
      YEAR([a].[PaidOrClosedDate]) as 'Year',
      COUNT(*) AS ApplicationsPaid,
      SUM(ISNULL([ap].[AnnualizedPremium], 0)) AS TotalPremiumPaid
    FROM [awu].[Application] [a]
      LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
      LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
      LEFT JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
    WHERE a.BranchTypeID in (SELECT * FROM @branchTable)
      AND st.[ApplicationStatusCode] in ('2', '3', 'P')
      AND st.[ScenarioTypeCode] = 'F'
      AND aa.CommissionLevel = 1
      AND YEAR([a].[PaidOrClosedDate]) > YEAR(GETDATE()) - 10
      AND (@_branch = 0 OR a.BranchTypeID = @_branch)
    GROUP BY YEAR([a].[PaidOrClosedDate])
    ORDER BY YEAR([a].[PaidOrClosedDate])

    END
    `,
            returnType: "table",
          },
        },
        {
          id: "agents-top-10",
          title: "Agents Top 10",
          widgetType: "table",
          options: { summary: true, grow: true },
          columns: [
            { name: "#", type: "number", style: { width: "24px", textAlign: "center" } },
            { name: "Name", type: "string" },
            { name: "Policies", type: "number", align: "right", summary: "sum" },
            { name: "Premium", type: "currency", align: "right", summary: "sum" },
          ],
          dataSource: {
            sql: `

-- declare @startDate date;
-- declare @endDate date;
-- declare @branch varchar(100);
-- set @startDate = '2024-01-01';
-- set @endDate = '2024-12-31';
-- set @branch = '1';

IF @branch IS NULL OR @branch = ''
BEGIN
    PRINT 'You must select a branch'
    RETURN
END
ELSE
BEGIN

-- Create a table variable to hold the branch IDs
DECLARE @branchTable TABLE (BranchID INT);
INSERT INTO @branchTable (BranchID)
SELECT TRY_CAST(value AS INT)
FROM STRING_SPLIT(@branch, ',')
WHERE TRY_CAST(value AS INT) IS NOT NULL;

SELECT TOP 10
    ROW_NUMBER() OVER (ORDER BY (SELECT 1)) AS number,
    b.FirstName + ' ' + b.LastName AS AgentName,
    COUNT(DISTINCT a.ID) AS ApplicationsPaid,
    SUM(ISNULL([ap].[AnnualizedPremium], 0) * ISNULL([aa].CommissionPercent, 0))  AS TotalPremiumPaid
FROM [awu].[Application] [a]
    LEFT JOIN [awu].[ApplicationPremium] [ap] ON [a].[ID] = [ap].[ApplicationID]
    LEFT JOIN [awu].[ApplicationStatus] [st] ON a.[ApplicationStatusID] = st.[ID]
    LEFT JOIN [awu].[ApplicationBroker] [aa] on a.ID = aa.ApplicationID
    LEFT JOIN [dbo].[Broker] [b] on aa.BrokerID = b.ID
WHERE
    a.BranchTypeID in (SELECT * FROM @branchTable)
    AND st.[ApplicationStatusCode] in ('2', '3', 'P')
    AND st.[ScenarioTypeCode] = 'F'
    AND [a].[PaidOrClosedDate] BETWEEN @startDate AND @endDate
    AND aa.CommissionLevel = 1
    AND (@_branch = 0 OR a.BranchTypeID = @_branch)
    -- AND DATEPART(YEAR, a.PaidOrClosedDate) = DATEPART(Year, @startDate AT TIME ZONE 'Pacific Standard Time')
    -- AND [a].[PaidOrClosedDate] BETWEEN @startDate AT TIME ZONE 'Pacific Standard Time' and @endDate AT TIME ZONE 'Pacific Standard Time'

GROUP BY b.ID, b.FirstName, b.LastName
ORDER BY TotalPremiumPaid DESC

END
`,
            returnType: "table",
          },
        },
      ],
    },
  ],
};

export default executiveSummary;
